import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { motion } from 'framer-motion';
import { Smartphone, Wallet, Key, Shield } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function LobbyKiosk() {
  // QR code points to the booking page with lobby mode (using HashRouter)
  const bookingUrl = `${window.location.origin}/#/book?source=lobby`;
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl w-full"
      >
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-400 mb-2">
            WELCOME TO
          </h1>
          <h2 className="text-6xl font-black text-white tracking-wider">
            HODLER INN
          </h2>
        </div>

        {/* Main Card */}
        <div className="bg-gray-800/50 backdrop-blur-sm border-2 border-orange-500/30 rounded-3xl p-8 text-center">
          <p className="text-2xl text-orange-400 font-semibold mb-6">
            No Reservation? No Problem.
          </p>

          {/* QR Code */}
          <div className="bg-white p-6 rounded-2xl inline-block mb-6 shadow-lg shadow-orange-500/20">
            <QRCodeSVG 
              value={bookingUrl}
              size={200}
              level="H"
              includeMargin={true}
              fgColor="#1a1a1a"
              bgColor="#ffffff"
            />
          </div>

          {/* Instructions */}
          <div className="space-y-4 text-left max-w-md mx-auto">
            <div className="flex items-center gap-4 text-gray-200">
              <div className="bg-orange-500/20 p-3 rounded-xl">
                <Smartphone className="w-6 h-6 text-orange-400" />
              </div>
              <span className="text-lg">Scan the QR code to meet <strong className="text-orange-400">Bitsy</strong></span>
            </div>
            
            <div className="flex items-center gap-4 text-gray-200">
              <div className="bg-orange-500/20 p-3 rounded-xl">
                <Shield className="w-6 h-6 text-orange-400" />
              </div>
              <span className="text-lg">Complete your digital check-in on your phone</span>
            </div>
            
            <div className="flex items-center gap-4 text-gray-200">
              <div className="bg-emerald-500/20 p-3 rounded-xl">
                <Wallet className="w-6 h-6 text-emerald-400" />
              </div>
              <span className="text-lg">
                <strong className="text-emerald-400">Save 10% instantly</strong> by paying with Crypto
              </span>
            </div>
            
            <div className="flex items-center gap-4 text-gray-200">
              <div className="bg-orange-500/20 p-3 rounded-xl">
                <Key className="w-6 h-6 text-orange-400" />
              </div>
              <span className="text-lg">Our team will bring your key immediately!</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-gray-500 text-sm">
          <p>820 US-59, Heavener, OK 74937 • (918) 653-7801</p>
          <p className="mt-1 text-orange-500/50">HOLD ON • Fair Pricing Principle</p>
        </div>
      </motion.div>
    </div>
  );
}
